import React from 'react';
import PropTypes from 'prop-types';

const InputElement = (props) => {

    let _inputElement = null;
    let inputClasses = ['form-control'];

    if (props.invalid && props.touched && props.isRequired && !inputClasses.includes('is-invalid')) {
        inputClasses.push('is-invalid');
    }

    switch (props.elementType) {
        case 'input':
            _inputElement = (
                <>
                    <input ref={props.inputRef != null ? props.inputRef : null}
                           id={props.id != null ? props.id : null}
                           className={inputClasses.join(' ')}
                           {...props.elementConfig}
                           onChange={props.changedValue}
                           value={props.value}
                           style={props.style ? props.style : null}
                    />
                    {(props.feedback) ? <div className='invalid-feedback'>{props.feedback}</div> : null}
                </>
            );
            break;
        case 'select':
            _inputElement = (
                <>
                    <select ref={props.inputRef != null ? props.inputRef : null}
                            id={props.id != null ? props.id : null}
                            className={inputClasses.join(' ')}
                            value={props.value ? props.value : ''}
                            onChange={props.changedValue}
                            style={props.style ? props.style : null}
                            disabled={props.elementConfig.disabled ? props.elementConfig.disabled : null}
                    >
                        {props.isRequired ?
                            null :
                            props.elementConfig.options.every(op => op.value !== '') ?
                                <option/> : null}

                        {props.elementConfig.options.map(option => (
                            <option key={Math.random().toString(33).slice(-5)}
                                    value={option.value}
                            >
                                {option.displayValue}
                            </option>
                        ))}
                    </select>
                    {(props.feedback) ? <div className='invalid-feedback'>{props.feedback}</div> : null}
                </>
            );
            break;
        case 'textarea':
            _inputElement = (
                <>
                    <textarea ref={props.inputRef != null ? props.inputRef : null}
                              id={props.id != null ? props.id : null}
                              className={inputClasses.join(' ')}
                              {...props.elementConfig}
                              value={props.value}
                              onChange={props.changedValue}
                              style={props.style ? props.style : null}>
                        {props.value}
                    </textarea>
                    {(props.feedback) ? <div className='invalid-feedback'>{props.feedback}</div> : null}
                </>
            );
            break;
        default:
            return null;
    }

    return (
        <div className={typeof props.classes === 'string' ? props.classes : props.classes.join(' ')}>
            {(props.elementType === 'select' || props.elementConfig.type !== 'checkbox') ? (
                <>
                    <label>
                        {props.label}
                        {props.isRequired &&
                            <sup className="text-danger" style={{fontSize: '20px', marginLeft: '5px'}}>*</sup>}
                    </label>
                    {_inputElement}
                </>
            ) : (
                <div className='d-inline-flex align-items-center justify-content-center mt-4'>
                    {_inputElement}
                    <label className='m-0'>
                        {props.label}
                        {props.isRequired &&
                            <sup className="text-danger" style={{fontSize: '20px', marginLeft: '5px'}}>*</sup>}
                    </label>
                </div>
            )}
        </div>
    );

};

InputElement.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    elementType: PropTypes.string.isRequired,
    elementConfig: PropTypes.shape({
        type: PropTypes.oneOf(['date', 'number', 'time', 'text', 'checkbox', 'textarea']),
        options: PropTypes.arrayOf(PropTypes.shape({
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                displayValue: PropTypes.string
            })
        ),
        name: PropTypes.string,
        checked: PropTypes.bool,
        placeholder: PropTypes.string,
        disabled: PropTypes.bool
    }).isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            value: PropTypes.string,
            displayValue: PropTypes.string
        }),
        PropTypes.number,
        PropTypes.array]
    ).isRequired,
    changedValue: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    touched: PropTypes.bool,
    isRequired: PropTypes.bool,
    classes: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    feedback: PropTypes.string,
    style: PropTypes.object

};

export default InputElement;

